import { LoginContext } from '../../../modules/login/AuthContext';
import { restApi } from '../../api';
import { FederatedSession } from './sso.types';

const SSO_EXCHANGE_PATH = '/auth/sso/exchange';

export const exchangeSsoHandoff = (handoffCode: string) =>
  restApi.post<FederatedSession>(SSO_EXCHANGE_PATH, { handoffCode }, { withCredentials: true });

export const getBrandLoginContext = (brandSlug: string) =>
  restApi.get<LoginContext>(`brands/${encodeURIComponent(brandSlug)}/login-context`);
